import {FeedbackOrigin} from '../../../../components/ai/DisclosureControls';
import {getFeedbackPreference} from '../../../../components/ai/aiDisclosure';
import React, { Component } from 'react';

import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import { Alert, Button } from '@betareader/design-system';
import './review.css';

// redux
import { push } from '../../../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import queryString from 'query-string';

import {
  fetchReview, updateReview, submitReview, clearReview
} from '../../../../modules/review';
import { fetchCurrentBookAsReader, resetCurrentBook } from '../../../../modules/book';

import { getFreshIdToken } from '../../../../utils/authUtil';

export class Review extends Component {
  constructor(props) {
    super(props);
    this.state = {
      aiOrigin: getFeedbackPreference(),
      reviewText: props.activeReview?.text ?? '',
      overAllRating: props.activeReview?.overAllRating ?? null,
      plotRating: props.activeReview?.plotRating ?? null,
      grammarRating: props.activeReview?.grammarRating ?? null,
      overAllRatingMissing: false,
      reviewAlreadyAdded: false,
      currentLength: props.activeReview?.text?.length ?? 0
    };
  }

  componentDidMount() {
    const { idToken, user } = this.props;
    const bookId = this.getCurrentBookId();
    this.setState({ bookId });
  }

  componentDidUpdate(prevProps) {
    const { bookId } = this.state;
    const {
      currentBook, loadingCurrentBook, idToken, user, activeReview, fetchingReview
    } = this.props;
    if (user !== undefined && currentBook === undefined && idToken !== undefined && !loadingCurrentBook) {
      this.props.fetchCurrentBookAsReader(idToken, bookId);
    }
    if (idToken !== undefined && !activeReview && bookId !== undefined && currentBook !== undefined && !fetchingReview) {
      this.props.fetchReview(idToken, bookId, review => this.setState({
        aiOrigin: 'undeclared',
        reviewText: review.text !== null ? review.text : '',
        overAllRating: review.overAllRating,
        plotRating: review.plotRating,
        grammarRating: review.grammarRating
      }));
    }
  }

  componentWillUnmount() {
    this.props.clearReview();
    this.props.resetCurrentBook();
  }

  getCurrentBookId = () => {
    const parsedQueryString = queryString.parse(this.props.location.search);
    const bookId = parsedQueryString.book;
    return bookId;
  }

  onChangeGeneralRating = (rating) => {
    this.setState({
      overAllRating: rating,
      overAllRatingMissing: false
    });
  }

  onChangeplotRating = (rating) => {
    this.setState({
      plotRating: rating
    });
  }

  onChangeGrammarRating = (rating) => {
    this.setState({
      grammarRating: rating
    });
  }

  onChangeReviewText = (event) => {
    const reviewText = event.target.value;
    this.setState({
      reviewText,
      currentLength: reviewText.length
    });
  }

  addReview = async (event) => {
    event?.preventDefault();
    if (this.state.aiOrigin !== 'personal') return;
    const {
      reviewText, overAllRating, plotRating, grammarRating, bookId
    } = this.state;
    const { activeReview } = this.props;
    const review = {
      aiOrigin: this.state.aiOrigin,
      overAllRating,
      plotRating,
      grammarRating,
      text: reviewText
    };
    if (!review.overAllRating) {
      this.setState({ overAllRatingMissing: true })
      return;
    }
    const idToken = await getFreshIdToken();
    // submit review and go to home view
    if (activeReview && activeReview._id) {
      this.props.updateReview(idToken, bookId, activeReview._id, review, e => this.handleServerResponse(e));
    } else {
      this.props.submitReview(idToken, bookId, review, e => this.handleServerResponse(e));
    }
  }

  handleServerResponse = (e) => {
    const { bookId } = this.state;
    if (e.status >= 400) {
      this.setState({submitError: e.msg || e.err || 'Could not save your review. Your draft is still here.'});
    } else {
      this.props.changePage(`/discover/${bookId}`)
    }
  }

  render() {
    const { t, userProfile, defaultFontSize, currentBook, history } = this.props;
    const {
      reviewText, overAllRating, plotRating, grammarRating,
      overAllRatingMissing, reviewAlreadyAdded, currentLength,
      submitError, aiOrigin
    } = this.state;
    const currentFontSize = userProfile?.readerSettings?.fontSize ?? defaultFontSize;
    const ratings = [
      { key: 'overall', label: t('Overall'), value: overAllRating, onChange: this.onChangeGeneralRating },
      { key: 'plot', label: t('Plot'), value: plotRating, onChange: this.onChangeplotRating },
      { key: 'grammar', label: t('Grammar'), value: grammarRating, onChange: this.onChangeGrammarRating }
    ];

    return (
      <main className={`br-review br-text font-size-${currentFontSize}`}>
        <h1>{t('Review')}</h1>
        {currentBook?.title && <h2>{currentBook.title}</h2>}
        {submitError && <Alert variant='error'>{submitError}</Alert>}
        <form className='br-review__form' onSubmit={this.addReview}>
          {ratings.map(({ key, label, value, onChange }) => (
            <fieldset className='br-review__rating' key={key}>
              <legend>{label}</legend>
              <div className='br-review__rating-choices'>
                {[1, 2, 3, 4, 5].map(rating => (
                  <label key={rating} className='br-review__rating-option'>
                    <input
                      type='radio'
                      name={key}
                      value={rating}
                      checked={value === rating}
                      aria-label={`${label}: ${rating} / 5`}
                      onChange={() => onChange(rating)}
                    />
                    <span aria-hidden='true'>★</span>
                    <span aria-hidden='true'>{rating}</span>
                  </label>
                ))}
              </div>
            </fieldset>
          ))}
          <label className='br-review__draft'>
            <span>{t('LeaveReview')}</span>
            <textarea
              maxLength={20000}
              placeholder={t('LeaveReview')}
              value={reviewText}
              onChange={this.onChangeReviewText}
            />
          </label>
          {currentLength > 0 && <span className='br-review__count'>{`${currentLength} / ${Number(20000).toLocaleString()}`}</span>}
          {overAllRatingMissing && <Alert>{t('OverallRatingRequired')}</Alert>}
          {reviewAlreadyAdded && <Alert>{t('Review already added')}</Alert>}
          <FeedbackOrigin value={aiOrigin} onChange={value => this.setState({ aiOrigin: value })} book={currentBook} />
          <div className='br-review__actions'>
            <Button type='button' variant='secondary' onClick={() => history.push('/')}>{t('Skip')}</Button>
            <Button type='submit' disabled={aiOrigin !== 'personal'}>{t('LeaveReview')}</Button>
          </div>
        </form>
      </main>
    );
  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  userProfile: state.user.userProfile,
  currentLanguage: state.user.currentLanguage,
  currentBook: state.book.currentBook,
  loadingCurrentBook: state.book.loadingCurrentBook,
  fontSizes: state.app.fontSizes,
  defaultFontSize: state.app.defaultFontSize,
  reviews: state.review.reviews,
  addReview: state.review.addReview,
  activeReview: state.review.activeReview,
  fetchingReview: state.review.fetchingReview,
  previousReviewExists: state.review.previousReviewExists
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchReview,
  updateReview,
  submitReview,
  fetchCurrentBookAsReader,
  clearReview,
  resetCurrentBook,
  changePage: newPage => push(newPage)
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Review)));
